import { AppIcons } from "../../../data/appIcons";
import { GridColumnType } from "../../../data/gridColumnType";

export const ViewResourcesListConfig = {
  columns: [
    {
      name: "Category",
      fieldName: "categoryName",
      colType: GridColumnType.Text,
    },
    {
      name: "Document",
      fieldName: "documentName",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete:false,
      },
      customAction: [
        {
          name: undefined,
          onViewAction: (data) => {
            alert("Viewing resource details");
          },
        },
      ],
    },
    {
      name: "Membership Type",
      fieldName: "membershipTypeName",
      colType: GridColumnType.Text,
    },
    {
      name: "Publish Date ",
      fieldName: "publishDate",
      colType: GridColumnType.DATE,
       colSettings: {
        format: 'DD MMM YYYY',
      }
    },
    {
      name: "Removal Date",
      fieldName: "removalDate",
      colType: GridColumnType.DATE,
       colSettings: {
        format: 'DD MMM YYYY',
      }
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: true,
      },
      customAction: [
        {
          name: "VIEW",
          iconName: AppIcons.editIconNew,
          onViewAction: (data) => {
            alert("Viewing resource details");
          },
        },
      ],
    },
  ],
};



